import React from 'react';

export const companiesData = [
  {
    name: 'recovery',
    title: 'Seu crédito foi cedido e a gestão de cobrança será realizada pela Recovery.',
    description: () => (
      <>
        Entre em <b>contato</b> através dos canais:
      </>
    ),
    selfService: 'https://www.gruporecovery.com',
    onlineChat: 'https://www.gruporecovery.com',
    email: '',
    appDescription: () => (
      <>
        <b>APP Grupo Recovery: </b> baixe pelo Play Store ou Apple Store
      </>
    ),
    phoneNumber: '0800 772 3331',
    onClickPhoneNumber: () => {
      document.location.href = 'tel:+5508007723331';
    },
    whatsapp: '11 4765 8402',
    onClickWhatsapp: () => {
      document.location.href = 'tel:+551147658402';
    },
  },
  {
    name: 'hoepers',
    title: 'Seu crédito foi cedido e a gestão de cobrança será realizada pela Hoepers.',
    description: () => (
      <>
        Entre em <b>contato</b> através dos canais:
      </>
    ),
    selfService: 'https://www.hoepers.com',
    onlineChat: null,
    email: 'sac@securitizadorahoepers.com',
    appDescription: () => null,
    phoneNumber: '0800 007 4230',
    onClickPhoneNumber: () => {
      document.location.href = 'tel:+5508000074230';
    },
    whatsapp: '51 2117-1992',
    onClickWhatsapp: () => {
      document.location.href = 'tel:+555121171992';
    },
  },
];
